if (!customElements.get('shipping-countdown')) {
  customElements.define(
    'shipping-countdown',
    class ShippingCountdown extends HTMLElement {
      connectedCallback() {
        this.textEl = this.querySelector('.product-shipping-countdown__text');
        this.timezone = this.dataset.timezone || 'Europe/Amsterdam';

        const weekday = this.parseTime(this.dataset.cutoffWeekday);
        const weekdayRaw = (this.dataset.cutoffWeekday || '').trim();
        const saturdayRaw = (this.dataset.cutoffSaturday || '').trim();
        const sundayRaw = (this.dataset.cutoffSunday || '').trim();
        // Index 0 = zondag ... 6 = zaterdag
        this.cutoffs = [
          this.parseTime(this.dataset.cutoffSunday),
          weekday,
          weekday,
          weekday,
          weekday,
          weekday,
          this.parseTime(this.dataset.cutoffSaturday),
        ];
        this.cutoffLabels = [sundayRaw, weekdayRaw, weekdayRaw, weekdayRaw, weekdayRaw, weekdayRaw, saturdayRaw];
        this.units = {
          hours: this.dataset.unitHours || 'u',
          minutes: this.dataset.unitMinutes || 'm',
          seconds: this.dataset.unitSeconds || 's',
        };

        if (!this.textEl || !this.cutoffs.some(Boolean)) return;

        this.tick = this.tick.bind(this);
        this.tick();
        this.interval = setInterval(this.tick, 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      parseTime(value) {
        if (!value) return null;
        const match = value.trim().match(/^(\d{1,2})[:.](\d{2})$/);
        if (!match) return null;
        const hours = Number(match[1]);
        const minutes = Number(match[2]);
        if (hours > 23 || minutes > 59) return null;
        return hours * 3600 + minutes * 60;
      }

      nowInTimezone() {
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: this.timezone,
          weekday: 'short',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hourCycle: 'h23',
        }).formatToParts(new Date());
        const get = (type) => {
          const part = parts.find((p) => p.type === type);
          return part ? part.value : '';
        };
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        return {
          day: days.indexOf(get('weekday')),
          seconds:
            (Number(get('hour')) % 24) * 3600 +
            Number(get('minute')) * 60 +
            Number(get('second')),
        };
      }

      tick() {
        const now = this.nowInTimezone();
        if (now.day < 0) return;

        for (let offset = 0; offset <= 7; offset++) {
          const cutoff = this.cutoffs[(now.day + offset) % 7];
          if (cutoff == null) continue;
          const remaining = offset * 86400 + cutoff - now.seconds;
          if (remaining <= 0) continue;
          this.render(remaining, offset, this.cutoffLabels[(now.day + offset) % 7]);
          return;
        }
      }

      render(remaining, offset, cutoffLabel) {
        const hours = Math.floor(remaining / 3600);
        const minutes = Math.floor((remaining % 3600) / 60);
        const seconds = remaining % 60;

        let time;
        if (hours > 0) {
          time = hours + ' ' + this.units.hours + ' ' + minutes + ' ' + this.units.minutes;
        } else if (minutes > 0) {
          time = minutes + ' ' + this.units.minutes + ' ' + seconds + ' ' + this.units.seconds;
        } else {
          time = seconds + ' ' + this.units.seconds;
        }

        let template;
        if (offset === 0) {
          template = this.dataset.textToday;
        } else if (offset === 1) {
          template = this.dataset.textTomorrow || this.dataset.textFuture;
        } else {
          template = this.dataset.textFuture;
        }
        if (!template) return;

        let dayName = '';
        if (template.indexOf('[dag]') !== -1) {
          dayName = new Intl.DateTimeFormat(document.documentElement.lang || 'nl', {
            weekday: 'long',
            timeZone: this.timezone,
          }).format(new Date(Date.now() + offset * 86400000));
        }

        const escapeHtml = (value) =>
          value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

        this.textEl.innerHTML = escapeHtml(template)
          .replace('[tijd]', '<strong>' + time + '</strong>')
          .replace('[cutoff]', escapeHtml(cutoffLabel || ''))
          .replace('[dag]', escapeHtml(dayName));
        this.classList.add('is-active');
      }
    }
  );
}
